<mat-card>
  <mat-card-header>
    <mat-card-title>Total de notas por Forma de Pagamento</mat-card-title>
    <mat-card-subtitle>
      últimos 7 dias
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <div style="display: block">
      <canvas
        baseChart
        [datasets]="data"
        [labels]="labels"
        [options]="options"
        [legend]="true"
        chartType="doughnut"
      >
      </canvas>
    </div>
  </mat-card-content>
</mat-card>